var _defs, _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIco2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#013177;}.cls-2{fill:#074ea3;}.cls-3{fill:#fff;}.cls-4{fill:#00a4e3;}.cls-5{fill:#33c3ef;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,32.14a5.7,5.7,0,0,1-1.1-.1v4.37a1.1,1.1,0,0,0,2.19,0V32A5.6,5.6,0,0,1,49.6,32.14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,33.24a6.76,6.76,0,1,1,6.75-6.76A6.76,6.76,0,0,1,49.6,33.24Zm0-11.32a4.57,4.57,0,1,0,4.56,4.56A4.57,4.57,0,0,0,49.6,21.92Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.85,42.44,31.59,36.7a1.09,1.09,0,0,0-1.53-.23l-5,3.74a1.13,1.13,0,0,0-.43.71,1.1,1.1,0,0,0,.21.82l4.25,5.73a1.11,1.11,0,0,0,.88.45,1,1,0,0,0,.65-.22l5-3.73a1.13,1.13,0,0,0,.43-.72A1.1,1.1,0,0,0,35.85,42.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.27,40.21l-5-3.74a1.13,1.13,0,0,0-.81-.2,1,1,0,0,0-.72.43l-4.26,5.74A1.09,1.09,0,0,0,63.68,44l5,3.73a1.11,1.11,0,0,0,.65.22l.16,0a1,1,0,0,0,.72-.43l4.26-5.73A1.09,1.09,0,0,0,74.27,40.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.46,45.65a33.75,33.75,0,1,0,9.89,23.87A33.53,33.53,0,0,0,73.46,45.65Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 49.6,
    cy: 69.52,
    r: 24.6,
    transform: "translate(-27 107.28) rotate(-80.74)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,95.21A25.7,25.7,0,1,1,75.29,69.52,25.72,25.72,0,0,1,49.6,95.21Zm0-49.2A23.51,23.51,0,1,0,73.1,69.52,23.53,23.53,0,0,0,49.6,46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,43.82a1.1,1.1,0,0,0-1.1,1.1v6.57a1.1,1.1,0,1,0,2.19,0V44.92A1.09,1.09,0,0,0,49.6,43.82Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,86.45a1.1,1.1,0,0,0-1.1,1.1v6.57a1.1,1.1,0,0,0,2.19,0V87.55A1.09,1.09,0,0,0,49.6,86.45Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.2,68.42H67.62a1.1,1.1,0,0,0,0,2.19H74.2a1.1,1.1,0,0,0,0-2.19Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.57,68.42H25a1.1,1.1,0,1,0,0,2.19h6.57a1.1,1.1,0,0,0,0-2.19Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64.47,53.55a1.1,1.1,0,0,0-1.07-.23c-9.22,3-14.59,15.25-14.81,15.77a1.1,1.1,0,0,0,1,1.52,1,1,0,0,0,.51-.13A45.68,45.68,0,0,0,56.72,66c4.61-3.79,7.33-7.62,8.09-11.39A1.08,1.08,0,0,0,64.47,53.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.84,72.8l-6.5-6.49a1.09,1.09,0,0,0-1.54,0L77,88.07l-9.85-9.84a1.08,1.08,0,0,0-1.54,0l-5.92,5.91a1.09,1.09,0,0,0,0,1.55l17.11,17.12a1.13,1.13,0,0,0,.78.32,1.09,1.09,0,0,0,.77-.32l28.46-28.46A1.09,1.09,0,0,0,106.84,72.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.31,88.05a1,1,0,0,0-.23.08l-9.9-9.9a1.08,1.08,0,0,0-1.54,0l-5.92,5.91a1.09,1.09,0,0,0,0,1.55l17,17a1.06,1.06,0,0,0,.56.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco2);
export default __webpack_public_path__ + "static/media/ico-2.b85f31970601acaa16e8dd0fe1bc0655.svg";
export { ForwardRef as ReactComponent };